/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechScreenMonitorOffIcon24Solid = forwardRef('TechScreenMonitorOffIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.134.366a1.25 1.25 0 1 0-1.768 1.768L3.29 4.058A3.99 3.99 0 0 0 2 7v7a4 4 0 0 0 4 4h3v2H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-2v-2h2.232l3.384 3.384a1.25 1.25 0 0 0 1.768-1.768L3.134.366Z" }),
        React.createElement("path", { d: "M22 14c0 .554-.113 1.082-.317 1.562L9.121 3H18a4 4 0 0 1 4 4v7Z" })));
});
